import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "../../config";
// import FlightDataBodyWrapper from "../../pages/Home/SelectFlight/FlightDataBodyWrapper";
import HeaderButtonsBox from "../../components/ConfirmBookingStatus/HeaderButtonsBox";
import PageBackHeader from "../../components/ConfirmBookingStatus/PageBackHeader";
import Button from "../../components/Button";
import FlightTicket from "../../components/ConfirmBookingStatus/FlightTicket";
// import FareSummary from "../../components/FareSummary";
import TravellerDetails from "../../components/ConfirmBookingStatus/TravellerDetails";
import JouryOrAckBox from "../../components/ConfirmBookingStatus/JouryOrAckBox";
// import Box from "../../components/Box";
import { DownloadTicketList } from "../../components/ConfirmBookingStatus/DownloadTicketList";
// import DetailsContainer from "../Home/SelectFlight/DetailsContainer";
import HeaderButtonWrapper from "../../components/ConfirmBookingStatus/HeaderButtonWrapper";
import { empBookingId } from "../../services/bookingServices";
import ErrorModal from "../../components/ErrorSuccessModal/ErrorModal";
import TravelDetail from "../../components/ConfirmBookingStatus/TravelDetail";
import { getFormattedTravelDetails } from "../../helper";
import { useLoaderContext } from "../../contexts/loaderContext";
import Box from "../../components/Box";
import TravelQuotation from "../../components/ConfirmBookingStatus/QuotationFile";
import BusinessTripDetails from "../../components/ConfirmBookingStatus/BusinessTripLeaveDetails";
import PerDiemDetails from "../../components/ConfirmBookingStatus/PerDiemDetails";
import { fetchUserData } from "../../services/userServices";
import Remarks from "../../components/ConfirmBookingStatus/Remarks";
import VisaQuotation from "../../components/ConfirmBookingStatus/VisaQuotation";
import OtherTickets from "../../components/ConfirmBookingStatus/OtherTickets";
import OtherTripDetails from "../../components/ConfirmBookingStatus/OtherTripDetails";
import { SpinnerLoader } from "../../components/SpinnerLoader";
// import { useIntercom } from "react-use-intercom";

const ConfirmBookingStatus = () => {
  let intercomUserId;
  let intercomOwnerId;
  const employeeDetails = localStorage.getItem("employeeData");
  const employee = JSON.parse(employeeDetails);

  // const { boot, hide } = useIntercom();
  const [activeCell, setActiveCell] = useState(1);
  // const [openDetails, setOpenDetails] = useState(-1);
  const { loading } = useLoaderContext();
  const [loader, setLoader] = useState(false);

  const bookingRef = useRef(null);

  const [flightTicketList, setFlightTicketList] = useState([]);
  const [employeeTicketCount, setEmployeeTicketCount] = useState(0);
  const [guestTicketCount, setGuestTicketCount] = useState(0);

  const location = useLocation();
  const navigate = useNavigate();
  const confirmFlightLocationUrl =
    location.pathname === "/user/dashboard/confirm-flights";
  const { id } = useParams();
  const [backendErrorMsg, setBackendErrorMsg] = useState(false);
  const [detailsData, setDetailsData] = useState([]);
  const [intercomId, setIntercomId] = useState();
  const [ownerId, setOwnerId] = useState();
  const [showMessage, setShowMessage] = useState(false);
  const [profileData, setProfileData] = useState({});
  const handleClick = (id) => {
    // hide();
    setActiveCell(id);
    const element = document.getElementById(id);
    element.scrollIntoView({ behavior: "smooth" });
  };

  // const setOpenCloseDetails = (detailNo) => {
  //   detailNo === openDetails ? setOpenDetails(-1) : setOpenDetails(detailNo);
  // };

  const closeErrorModal = () => {
    navigate("/user/bookings");
  };

  useEffect(() => {
    getBookingDetails();
    // setFlightTicketList(DownloadTicketList);
    setEmployeeTicketCount(2);
    // employee array length or employee count from backend or iterate and find count
    setGuestTicketCount(1);
    // guest array length or guest count from backend or iterate and find count
  }, [id]); // eslint-disable-line

  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          // hide();
          setShowMessage(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const getBookingDetails = async () => {
    console.log(id);
    setLoader(true);
    try {
      const response = await empBookingId(id);
      // let data = await fetchUserData();
      // setProfileData({ ...data?.data });
      console.log(response);
      setLoader(false);
      if (response.status === 200) {
        const responseData = response.data.data;
        setDetailsData(getFormattedTravelDetails(responseData));
        // boot({
        //   name: employee.firstName + " - " + responseData.requestId,
        //   userId: responseData.requestId,
        //   email: employee.email,
        // });
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      setBackendErrorMsg(error.message);
    }
  };

  useEffect(() => {
    bookingRef.current.scrollIntoView();
  }, []);

  return (
    <>
      {!loading && loader && (
        <div style={{ position: "absolute", top: 0, left: 0 }}>
          <SpinnerLoader />
        </div>
      )}
      <FlightSummaryContainer ref={bookingRef}>
        <PageBackHeader
          confirmFlightLocationUrl={confirmFlightLocationUrl}
          status={detailsData.status}
          requestId={detailsData.requestId}
          isBusinessTrip={detailsData?.isBusinessTrip}
          hasChildDocument={detailsData?.hasChildDocument}
          customerEndCancel={detailsData?.customerEndCancel}
          onShowChat={() => setShowMessage(true)}
          id={detailsData?._id}
        />
        <FlightSummaryWrapper>
          <RowWrapper>
            <LeftColumnWrapper>
              <HeaderButtonsBox
                activeCell={activeCell}
                handleClick={handleClick}
                confirmFlightLocationUrl={confirmFlightLocationUrl}
                requestId={detailsData.requestId}
                isBusinessTrip={detailsData?.isBusinessTrip ? true : false}
              />
              {!confirmFlightLocationUrl && (
                <TravelDetail
                  profileData={profileData}
                  detailsData={detailsData}
                  isBusinessTrip={detailsData?.isBusinessTrip ? true : false}
                />
              )}
              {/* <FlightSummaryHeaderWrapper>
              <TextFont
                fontColor={Colors.paleCornflowerBlue}
                fontSize="1rem"
                fontWeight="500"
              >
                Employee Flight Details
              </TextFont>
            </FlightSummaryHeaderWrapper>
            <FlightSummarySectionWrapper id={1}>
              <Box>
                <div>
                  <FlightDataBodyWrapper
                    detailNo={0}
                    flightName="Qatar Airways"
                    isConfirmBookingPage={true}
                    imgSrc={require("../../assets/images/Qatar-Airways-Logo.png")}
                    openDetails={openDetails}
                    setOpenDetails={(detailNo) => setOpenCloseDetails(detailNo)}
                  />
                </div>
              </Box>
              {openDetails === 0 && (
                <DetailsContainer flightName="Qatar Airways" />
              )}

              <FlightSummaryHeaderWrapper>
                <TextFont
                  fontColor={Colors.paleCornflowerBlue}
                  fontSize="1rem"
                  fontWeight="500"
                >
                  Guest Flight Details
                </TextFont>
              </FlightSummaryHeaderWrapper>

              <Box>
                <div>
                  <FlightDataBodyWrapper
                    detailNo={1}
                    flightName="Qatar Airways"
                    isConfirmBookingPage={true}
                    imgSrc={require("../../assets/images/Qatar-Airways-Logo.png")}
                    openDetails={openDetails}
                    setOpenDetails={(detailNo) => setOpenCloseDetails(detailNo)}
                  />
                </div>
              </Box>
              {openDetails === 1 && (
                <DetailsContainer flightName="Qatar Airways" />
              )}
            </FlightSummarySectionWrapper> */}
              {detailsData.isBusinessTrip && (
                <div id={2}>
                  <BusinessTripDetails data={detailsData.leaveId} />
                </div>
              )}
              {detailsData.isBusinessTrip && (
                <div id={2}>
                  <OtherTripDetails data={detailsData?.travelDetails[0]} />
                </div>
              )}
              {/* <div id={2}>
              <PerDiemDetails />
            </div> */}
              <div id={2}>
                <TravellerDetails
                  confirmFlightLocationUrl={confirmFlightLocationUrl}
                  guestTicketCount={guestTicketCount}
                  detailsData={detailsData}
                  profileData={profileData}
                />
              </div>

              {/* {detailsData?.travelDetails?.length > 0 &&
              detailsData?.travelDetails[0]?.businessTripReqs?.length && (
                <div id={3}>
                  <BoxWrapper>
                    <Box boxPadding="2rem 2rem 2rem 2rem">
                      <CommentHeader>Business Requirements</CommentHeader>
                      <BRGrid>
                        {detailsData?.travelDetails[0]?.businessTripReqs?.map(
                          (btr) => (
                            <div style={{ flex: 1, paddingRight: "2rem" }}>
                              <Header>{btr?.name}</Header>
                              <Value>
                                {btr?.selected
                                  ? btr?.selected
                                  : btr.amount
                                  ? btr.currency + " " + btr.amount
                                  : btr?.isChecked
                                  ? "Yes"
                                  : "No"}
                              </Value>
                            </div>
                          )
                        )}
                      </BRGrid>
                    </Box>
                  </BoxWrapper>
                </div>
              )} */}

              {detailsData?.bookingComments && (
                <div id={3}>
                  <BoxWrapper>
                    <Box boxPadding="2rem 2rem 2rem 2rem">
                      <CommentHeader>Special Request</CommentHeader>
                      <Comment>{detailsData?.bookingComments}</Comment>
                    </Box>
                  </BoxWrapper>
                </div>
              )}
              <div id={4}>
                <JouryOrAckBox
                  confirmFlightLocationUrl={confirmFlightLocationUrl}
                  detailsData={detailsData}
                  isBusinessTrip={detailsData?.isBusinessTrip}
                />
              </div>
            </LeftColumnWrapper>
            <FareSummaryFlightTicketWrapper>
              {/* <FareSummary
              confirmFlightLocationUrl={confirmFlightLocationUrl}
            /> */}
              {!confirmFlightLocationUrl && (
                <FlightTicket
                  flightTicket={detailsData?.ticketPdf}
                  employeeTicketCount={employeeTicketCount}
                  guestTicketCount={guestTicketCount}
                />
              )}
              {!confirmFlightLocationUrl && detailsData?.isBusinessTrip && (
                <OtherTickets
                  flightTicket={detailsData?.documentPdf}
                  employeeTicketCount={1}
                  guestTicketCount={1}
                />
              )}
              {detailsData?.isBusinessTrip && (
                <>
                  <TravelQuotation
                    flightTicket={
                      detailsData?.ticketQuotation?.fileUrl
                        ? [detailsData?.ticketQuotation?.fileUrl]
                        : []
                    }
                    label="Ticket"
                  />
                  <VisaQuotation
                    flightTicket={
                      detailsData?.visaQuotation?.fileUrl
                        ? [detailsData?.visaQuotation?.fileUrl]
                        : []
                    }
                  />
                  <TravelQuotation
                    flightTicket={
                      detailsData?.hotelQuotation?.fileUrl
                        ? [detailsData?.hotelQuotation?.fileUrl]
                        : []
                    }
                    label="Other"
                  />
                  <Remarks remarks={detailsData?.remarks} />
                </>
              )}
            </FareSummaryFlightTicketWrapper>
          </RowWrapper>
          {confirmFlightLocationUrl && (
            <ActionWrapper>
              <ButtonWrapper>
                <Button
                  label="Cancel Request"
                  bgColor={Colors.transparent}
                  outlineColor={Colors.white}
                  width="12.5rem"
                  topBottomPadding="0.938rem"
                  onClick={console.log("Cancel Request")}
                />
                <Button
                  label="Submit Request"
                  bgColor={Colors.mediumCandyAppleRed}
                  width="12.5rem"
                  topBottomPadding="0.938rem"
                  onClick={() => navigate("/user/bookings")}
                />
              </ButtonWrapper>
            </ActionWrapper>
          )}
          {!confirmFlightLocationUrl && (
            <MobileButtonView>
              <HeaderButtonWrapper
                status={detailsData.status}
                hasChildDocument={detailsData.hasChildDocument}
                requestId={detailsData.requestId}
                isBusinessTrip={detailsData?.isBusinessTrip}
                onShowChat={() => setShowMessage(true)}
                navigate={navigate}
                id={detailsData?._id}
              />
            </MobileButtonView>
          )}
        </FlightSummaryWrapper>
        {backendErrorMsg && (
          <ErrorModal
            subheaderText={backendErrorMsg}
            setClose={closeErrorModal}
            onButtonClick={closeErrorModal}
          />
        )}
        <ChatWrapper ref={wrapperRef}>
          {showMessage && (
            <ChatMessage>
              <div>
                Apologies for the inconvenience, as our chat service is
                presently undergoing maintenance.
              </div>
              <div>
                During this period, Joury agents will reachout to you regarding
                your request.
              </div>
              <div>
                For urgent matters, please feel free to email us at{" "}
                <a href="mailto:reservations@jourytravels.com">
                  reservations@jourytravels.com
                </a>
                .
              </div>
              <div>We appreciate your understanding.</div>
            </ChatMessage>
          )}
          <ChatButton onClick={() => setShowMessage(!showMessage)}>
            {showMessage ? (
              <img src={require("../../assets/images/close_white.png")} />
            ) : (
              <img src={require("../../assets/images/Send.png")} />
            )}
          </ChatButton>
        </ChatWrapper>
      </FlightSummaryContainer>
    </>
  );
};

const ChatButton = styled.button`
  height: 3rem;
  width: 3rem;
  border: none;
  border-radius: 50%;
  background: ${Colors.brandTwo};
  transition-duration: 250ms;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    box-shadow: 0px 0px 5px #000000;
  }
`;
const ChatMessage = styled.div`
  padding: 1rem;
  background: white;
  width: 100%;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  > div {
    margin-bottom: 0.5rem;
    > a {
      color: ${Colors.brandTwo};
    }
  }
`;
const ChatWrapper = styled.div`
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  width: 20rem;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  @media only screen and (max-width: 769px) {
    bottom: 0.5rem;
    right: 0.5rem;
  }
`;

const BoxWrapper = styled.div`
  margin-top: 1.5rem;
`;
const CommentHeader = styled.div`
  color: ${Colors.brandTwo};
  font-size: 0.875rem;
  margin-bottom: 1rem;
`;
const Comment = styled.div`
  font-size: 0.875rem;
`;
const FlightSummaryContainer = styled.div`
  padding: 1.875rem 2.5rem;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const FlightSummaryWrapper = styled.div`
  padding: 1.5rem 0rem 0rem;
`;

const RowWrapper = styled.div`
  display: flex;
  gap: 1.813rem;
  width: 100%;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const BRGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Header = styled.div`
  color: rgb(142, 142, 161);
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
`;

const Value = styled.div`
  color: rgb(34, 36, 44);
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
`;

const LeftColumnWrapper = styled.div`
  display: flex;
  width: 77%;
  flex-direction: column;
  gap: 1rem;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const ActionWrapper = styled.div`
  padding-top: 2.313rem;
  display: flex;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  gap: 0.75rem;
  justify-content: center;
`;

// const FlightSummarySectionWrapper = styled.div`
//   padding-top: 0.625rem;
//   display: flex;
//   flex-direction: column;
//   gap: 0.625rem;
// `;

// const JouryOrAckBoxWrapper = styled.div`
//   padding-top: 1.188rem;
// `;

const FareSummaryFlightTicketWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.375rem;
  width: 23%;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const HeaderWrapper = styled.div`
  padding: 1.875rem 1.875rem 0.75rem;
  @media only screen and (max-width: 768px) {
    padding-left: 0rem;
  }
`;

// const FlightSummaryHeaderWrapper = styled.div`
//   padding: 0.875rem 1.875rem 0.5rem;
// `;

const MobileButtonView = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
    margin-top: 2rem;
  }
`;
export default ConfirmBookingStatus;
